/*
 * @Author: Dong
 * @Date: 2022-04-11 16:19:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-18 16:36:32
 */
import { defineMessages } from 'react-intl';

const object: { [key: string]: string } = {
  systemTitle: '工业操作系统',
  systemUninstallTip: '请确定卸载supOS?',
  version: '版本',
  installModalTitle: '安装包列表',
  upgradeModalTitle: '配置升级文件',
  install: '安装',
  upgrade: '升级',
  uninstall: '卸载',
  systemCancelTip: '取消supOS{type}会取消所有组件安装，请确定取消？',
  cancelTip: '确认取消{type}组件吗？',
  failedUnintall: '卸载失败',
  waiting: '正在等待',
  reInstallCoverTip: '当前任务已安装成功，是否覆盖？',
  cancelCoverTip: '当前任务已安装成功，请悉知!',
  suposRunningTip: '请先启动supOS，安装其他组件依赖于supOS运行',
  runing: '运行中',
  notinstall: '未安装',
  reInstall: '重新',
  cancel: '取消',
  failed: '失败',
  detail: '详情',
  supPalntAuthorized: '请输入授权地址',
  dependNullTip: `安装{name}时必选{dependName}`,
  dependVerisonTip: '所选的{name}与{dependName}版本不兼容',
  returnSystem: '返回系统管理',
  downloadLog: '日志下载',
  upgradeTitle: '确认要现在开始升级吗?',
  clusteredUpgradeContent: '升级过程可能会持续2个小时，在此期间会影响supOS的正常使用，您确认现在要进行升级吗?',
  upgradeContent: '升级过程中可能会影响supOS的正常使用，您确认现在要进行升级吗?',
  extension: '扩展组件',
  middleware: '中间件',
  app: 'APP',
  system: '系统',
  waitingMiddleware: '等待中间件',
  rollBack: '回滚',
  disturbanceUpgradeProtocol: '请确认升级影响并同意',
  disturbance: '有扰升级',
  undisturbed: '无扰升级',
  continueInstall: '继续安装',
  undisturbedText: '无扰',
  disturbanceText: '有扰',
  pointsForAttention: '注意事项',
  decompressionPrompt: '解压中，解压时间可能较长，请稍等...',
  logNull: '未查询到安装日志',
  selectedExtended: '所选的扩展组件中',
  installBtnTip: '重新执行一次安装过程，不重新配置',
  upgradeBtnTip: '重新执行一次升级过程',
  cancelinstallTip: '取消后，再次安装从第一步开始配置',
  cancelupgradeTip: '取消后将回到supOS运行状态页面',
};

export default defineMessages(object);
